import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  ready_for_inspection: 'Ready for inspection',
  engineer_nominated: 'Engineer nominated',
  inspection_completed: 'Completed',
  approved: 'Approved',
  rejected: 'Rejected',
};

@Component({
  selector: 'app-segment-inspection-list',
  templateUrl: './segment-inspection-list.component.html',
  styleUrls: ['./segment-inspection-list.component.css'],
})
export class SegmentInspectionListComponent implements OnInit, AfterViewInit {
  displayedColumns = ['srNo', 'project', 'segment', 'plannedDate', 'engineer', 'status', 'action'];
  dataSource = new MatTableDataSource<Record<string, unknown>>([]);
  statusFilter = '';
  showMyAssignments = false;
  statusLabels = STATUS_LABELS;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private api: ApiService,
    private toastr: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  load(): void {
    this.api
      .listSegmentInspections({
        status: this.statusFilter || undefined,
        assigned_to_me: this.showMyAssignments,
      })
      .subscribe({
        next: (res: { data?: Record<string, unknown>[] }) => {
          this.dataSource.data = res.data || [];
        },
        error: (err) => this.toastr.error(err?.error?.message || 'Failed to load segment inspections'),
      });
  }

  applyFilter(event: Event): void {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      draft: 'status-draft',
      ready_for_inspection: 'status-ready',
      engineer_nominated: 'status-nominated',
      inspection_completed: 'status-done',
      approved: 'status-done',
      rejected: 'status-rejected',
    };
    return map[status] || 'status-draft';
  }

  segmentLabel(row: Record<string, unknown>): string {
    if (row['segment_label']) return String(row['segment_label']);
    if (row['from_km'] && row['to_km']) return `Km ${row['from_km']} – ${row['to_km']}`;
    return row['segment_code'] ? String(row['segment_code']) : '—';
  }

  openDetail(row: { id: number }): void {
    void this.router.navigate(['/home/segment-inspection', row.id]);
  }

  deleteRow(row: { id: number; project_name?: string }): void {
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '400px',
      data: { itemName: row.project_name || 'segment inspection' },
    });
    ref.afterClosed().subscribe((ok) => {
      if (!ok) return;
      this.api.deleteSegmentInspection(row.id).subscribe({
        next: () => {
          this.toastr.success('Deleted');
          this.load();
        },
        error: (err) => this.toastr.error(err?.error?.message || 'Delete failed'),
      });
    });
  }
}
